import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseFilterCellComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { debounceTime } from 'rxjs/operators'

@Component({
    selector: 'dashboard-grid-text-filter',
    template: `
    <input kendoTextBox style="width: 100% !important;" type="text" [value]="filterText" [formControl]="filterInput" [placeholder]="placeholder" />  
  `
})
export class DashboardTextFilterComponent extends BaseFilterCellComponent implements OnInit {
    @Input('filter') override filter!: CompositeFilterDescriptor;
    @Input('placeholder') placeholder!: string;
    @Input('field') field!: string;
    @Input('filterOperator') filterOperator!: string; // eq, contains, startswith, endswith, ....

    public filterText!: string;
    public filterInput = new FormControl();

    constructor(filterService: FilterService) {
        super(filterService);
    }

    ngOnInit() {
        let filter = this.filterByField(this.field);
        if(filter) {
            this.filterText = filter.value;
            this.filterInput.patchValue(this.filterText);
        } else {
            this.filterText = '';
        }

        this.filterInput
            .valueChanges
            .pipe(debounceTime(250))
            .subscribe(term => {
                this.filterText = term;
                this.filterGrid(term);
            });
    }

    private filterGrid(value: any): void {
        this.applyFilter(
            value === null ? // value of the default item
                this.removeFilter(this.field) : // remove the filter
                this.updateFilter({ // add a filter for the field with the value
                    field: this.field,
                    operator: this.filterOperator,
                    value: value
                })
        ); // update the root filter
    }
}
